import React, { useState } from "react";
import { Link } from "react-router-dom";


import "../InfoProject.css";
import { BackArrowIcon2, scrollxLogo } from "../../../assets/icons";

export default function FontNewUser() {
  const [activeFont, setActiveFont] = useState(""); // State to track active element id
  const [fontOPt, setFontOPt] = useState(true);
  const [fontFamilyOPt, setFontFamilyOPt] = useState(false);
  const [fontWeight, setFontWigtht] = useState(false);
  const [fontColoropt, setFontColoropt] = useState(false);
  const [fontSizeopt, setFontSizeopt] = useState(false);
  const [fontlineheightopt, setFontlineheightopt] = useState(false);
  const [fonttextTranformopt, setFonttextTranformopt] = useState(false);
  const [fontletterSpacingopt, setFontletterSpacingopt] = useState(false);

  const nextToContinue = (id) => {
    setActiveFont(id); // Set the active state to the id of the clicked element
    if (id === "FontFamilytype") {
      setFontFamilyOPt(true);
      setFontOPt(false);
      setFontColoropt(false);
      setFontWigtht(false);
      setFontlineheightopt(false);
      setFonttextTranformopt(false);
      setFontletterSpacingopt(false);
      setFontSizeopt(false);
    } else if (id === "FontWeighttype") {
      setFontWigtht(true);
      setFontFamilyOPt(false);
      setFontOPt(false);
      setFontColoropt(false);
      setFontlineheightopt(false);
      setFonttextTranformopt(false);
      setFontletterSpacingopt(false);
      setFontSizeopt(false);
    } else if (id === "FontColortype") {
      setFontColoropt(true);
      setFontWigtht(false);
      setFontFamilyOPt(false);
      setFontOPt(false);
      setFontlineheightopt(false);
      setFonttextTranformopt(false);
      setFontletterSpacingopt(false);
      setFontSizeopt(false);
    } else if (id === "FontSizetype") {
      setFontSizeopt(true);
      setFontColoropt(false);
      setFontWigtht(false);
      setFontFamilyOPt(false);
      setFontOPt(false);
      setFontlineheightopt(false);
      setFonttextTranformopt(false);
      setFontletterSpacingopt(false);
    } else if (id === "Lineheighttype") {
      setFontlineheightopt(true);
      setFontSizeopt(false);
      setFontColoropt(false);
      setFontWigtht(false);
      setFontFamilyOPt(false);
      setFontOPt(false);
      setFonttextTranformopt(false);
      setFontletterSpacingopt(false);
    } else if (id === "textTranformtype") {
      setFonttextTranformopt(true);
      setFontlineheightopt(false);
      setFontSizeopt(false);
      setFontColoropt(false);
      setFontWigtht(false);
      setFontFamilyOPt(false);
      setFontOPt(false);
      setFontletterSpacingopt(false);
    } else if (id === "letterSpacingtype") {
      setFontletterSpacingopt(true);
      setFonttextTranformopt(false);
      setFontlineheightopt(false);
      setFontSizeopt(false);
      setFontColoropt(false);
      setFontWigtht(false);
      setFontFamilyOPt(false);
      setFontOPt(false);
    }
  };
  return (
    <div className="w-full h-full">
      {/* Header */}
      <div className="h-[64px] px-[10%] w-full flex items-center justify-between LayoutNewUser-nav">
      <Link to="/dashboard/projectInstructions">
      <nav className=" flex items-center">
          <img
            className="ml-[-22px]    w-[47px]"
            src={BackArrowIcon2}
            alt=""
            style={{ cursor: "pointer" }}
          />
              <img className="w-[42px] h-[50px] mr-2" src={scrollxLogo} />
              <h1 className="Syne text-xl font-extrabold tracking-wide ml-[-0.4rem] text-[#dee3eb]">
              {" "}
              SCROLLX.io <span className="Syne text-lg  tracking-wide text-[#dee3eb]">help</span>
            </h1>
          </nav>
      </Link>
        <div>
          <button className="text-[18px] text-white rounded border-[1px] px-3  py-1">
            Go to website
          </button>
        </div>
      </div>
      <div className="px-[10%] flex h-full">
        <div className="w-3/5  py-5">
          <div
            className={fontOPt === true ? "InfoOverlay " : "InfoOverlayNone"}
          >
            {fontOPt && (
              <div className="w-[90%] pr-[10%] h-[90%] overflow-y-auto ">
                <h1 className="py-3 text-4xl FontFamily-Avenir">
                  Getting Started with Fonts
                </h1>
                <h2 className="text-[20px] FontFamily-Avenir-reg py-2 ">
                  ScrollX provides a robust suite of tools to fine-tune your
                  typographic design.
                </h2>
                <h3 className="py-1 text-[18px] FontFamily-Avenir-reg">
                  Our style-based approach allows you to individually adjust the
                  font weight, size, and color for each of these seven elements:
                </h3>
                <li className=" text-[18px] FontFamily-Avenir-reg">Roles</li>
                <li className=" text-[18px] FontFamily-Avenir-reg">Names</li>
                <li className=" text-[18px] FontFamily-Avenir-reg">
                  Blurbs (Paragraphs)
                </li>
                <li className=" text-[18px] FontFamily-Avenir-reg">Headings</li>
                <li className=" text-[18px] FontFamily-Avenir-reg">
                  Subheadings
                </li>
                <li className=" text-[18px] FontFamily-Avenir-reg">
                  Song/Media Titles
                </li>
                <li className=" text-[18px] FontFamily-Avenir-reg">
                  Song/Media Details
                </li>
                <h3 className="py-2 text-[18px] FontFamily-Avenir-reg">
                  By maintaining consistent typographic styles throughout the
                  entire title sequence, you ensure your design remains clean,
                  visually appealing, and typographically superb.
                </h3>
                <h1 className="py-2 text-2xl FontFamily-Avenir">
                  Choosing a Style
                </h1>
                <h3 className=" text-[18px] FontFamily-Avenir-reg">
                  Click on the row of the style you want to modify. In the
                  example below, we are selecting "Roles." <br /> In the preview
                  pane, you'll notice that all other text becomes blurred and
                  dimmed. This helps you focus exclusively on the style you are
                  currently editing.
                </h3>
              </div>
            )}
          </div>
          {/* Font family */}
          <div
            className={
              fontFamilyOPt === true ? "InfoOverlay " : "InfoOverlayNone"
            }
          ></div>
          {fontFamilyOPt && (
            <div className="w-[90%] pr-[10%] h-[90%] overflow-y-auto scroll_bar">
              <div>
                <h1 className="py-3 text-black FontFamily-Avenir text-4xl FontFamily-Avenir">
                  Font Feature: Font Family
                </h1>
              </div>
              <div className="">
                <h2 className="py-2 text-black FontFamily-Avenir-reg text-[20px]">
                  To set a Font Family (also known as Typeface), follow these
                  steps:
                </h2>
                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  Select the Style You Want to Edit
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Choose the specific text style you wish to change. In this
                  example, we are editing 'Names.'
                </li>
                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  Click on Font Family
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Find and click on the 'Font Family' option in your text
                  editor's toolbar or formatting menu.
                </li>
                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  Preview Font Families
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Hover over the names of different font families in the list to
                  see a preview of each font. This allows you to see how the
                  font will look before making a selection.
                </li>
                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  Set the Font Family
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Click on the desired font family to apply it to the selected
                  text style. The text style will update to reflect the new font
                  choice.
                </li>
                <img
                  className="py-3"
                  src="https://scrollx-gif-uploads.s3.amazonaws.com/Fonts/Webp/Fonts-Font-Library-Options_240305.webp"
                  alt=""
                />
              </div>
            </div>
          )}
          {/* Font Weight */}
          <div
            className={fontWeight === true ? "InfoOverlay " : "InfoOverlayNone"}
          ></div>
          {fontWeight && (
            <div className="w-[90%] pr-[10%] h-[90%] overflow-y-auto scroll_bar">
              <div>
                <h1 className="py-3 text-black FontFamily-Avenir text-4xl FontFamily-Avenir">
                  Font Feature: Font Weight
                </h1>
              </div>
              <div className="w-full">
                <h2 className="py-2 text-black FontFamily-Avenir-reg text-[20px]">
                  Font weight refers to the thickness of the characters in a
                  typeface, affecting the visual impact and readability of text.
                  It is an essential attribute in typography, used to create
                  emphasis, hierarchy, and contrast within a text. Font weights
                  are typically described using terms like "light," "regular,"
                  "bold," and "extra-bold," or by numerical values, often
                  ranging from 100 to 900.
                </h2>
                <h3 className="py-2 text-black FontFamily-Avenir text-3xl">
                  Key Aspects of Font Weight:
                </h3>
                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  1. Visual Impact and Emphasis
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Bold Weights: Heavier or bolder font weights (e.g., "bold,"
                  "extra-bold") are used to draw attention to specific elements,
                  such as headings, subheadings, or important text. They stand
                  out more prominently, making the text more noticeable.
                </li>
                <li className="py-1">
                  Lighter Weights: Lighter font weights (e.g., "light," "thin")
                  create a subtle and elegant appearance. They are often used
                  for large display text or to create a sophisticated,
                  minimalist look.
                </li>
                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  2. Hierarchy and Structure
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Using varying font weights helps establish a visual hierarchy
                  in a document or design. For example, headings might be set in
                  a bold weight, subheadings in a regular weight, and body text
                  in a light or regular weight. This differentiation makes it
                  easier for readers to navigate and understand the content
                  structure.
                </li>

                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  3. Readability and Legibility
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  The appropriate font weight contributes to the readability and
                  legibility of text. Heavier weights can improve readability in
                  low-light conditions or for people with visual impairments.
                  However, extremely bold weights may reduce legibility in dense
                  blocks of text. Conversely, very light weights can be
                  challenging to read, especially at small sizes or on screens
                  with lower resolutions.
                </li>
                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  4. Stylistic Choices
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Font weight also plays a role in the overall aesthetic and
                  style of a design. Different weights can convey different
                  tones and moods. For instance, a bold weight can impart
                  strength and confidence, while a light weight can suggest
                  delicacy and elegance.
                </li>
                <h3 className="py-3 text-black FontFamily-Avenir text-3xl">
                  How to Change Font Weight
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  In the Fonts section of your project, select the style you
                  wish to edit. Then, click on Font Weight. Hover over or scroll
                  through the available weights to preview them. Click to set
                  the desired weight.
                </li>
                <img
                  className="py-3 "
                  src="https://scrollx-gif-uploads.s3.amazonaws.com/Fonts/Webp/Fonts-Font-Weight-Options_240305.webp"
                  alt=""
                />
                <h3 className="py-3 text-black FontFamily-Avenir text-3xl">
                  Numerical Font Weights:
                </h3>
                <h3 className="py-1 text-black FontFamily-Avenir-reg text-[20px]">
                  In CSS and digital typography, font weights are often defined
                  numerically:
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">100: Thin</li>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  200: Extra Light (Ultra Light)
                </li>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  300: Light
                </li>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  400: Normal (Regular)
                </li>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  500: Medium
                </li>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  600: Semi Bold (Demi Bold)
                </li>
                <li className="FontFamily-Avenir-reg text-[17px]">700: Bold</li>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  800: Extra Bold (Ultra Bold)
                </li>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  900: Black (Heavy)
                </li>
                <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                  These numerical values provide precise control over font
                  weight, allowing for fine-tuning of text appearance in web
                  design and digital applications.
                </h3>
                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  Conclusion
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Font weight is a fundamental aspect of typography, influencing
                  the visual hierarchy, readability, and overall aesthetics of
                  text. By understanding and effectively using different font
                  weights, designers and typographers can enhance the clarity,
                  impact, and appeal of their work.
                </li>
              </div>
            </div>
          )}
          {/* Font Color */}
          <div
            className={
              fontColoropt === true ? "InfoOverlay " : "InfoOverlayNone"
            }
          ></div>
          {fontColoropt && (
            <div className="w-[90%] pr-[10%] h-[90%] overflow-y-auto scroll_bar">
              <div>
                <h1 className="py-3 text-black FontFamily-Avenir text-4xl FontFamily-Avenir">
                  Font Feature: Font Color
                </h1>
              </div>
              <div className="w-full">
                <h2 className="py-2 text-black FontFamily-Avenir-reg text-[20px]">
                  Credits don’t have to be limited to black and white! Adding a
                  touch of color can greatly enhance their appearance. You might
                  choose vibrant colors or simply adjust white letters to a
                  lighter shade of gray.
                </h2>
                <h3 className="py-2 text-black FontFamily-Avenir text-3xl">
                  How to Change Font Color
                </h3>
                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  1. Select the Style to Edit
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Navigate to the Fonts section of your project and choose the
                  style you want to modify.
                </li>

                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  2. Open the Color Picker
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Click on the font color square to open the color picker
                  widget.
                </li>

                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  3. Choose Your Color
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Use the color picker to select your desired color. Changes
                  will be visible in real time.
                </li>
                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  4. Hexadecimal Values
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  The color is represented as a 6-digit hexadecimal number. For
                  example, white is #ffffff and red is #ff0000.
                </li>

                <h3 className="py-2 text-black FontFamily-Avenir-reg text-[20px]">
                  Experiment with different colors to achieve the perfect look
                  for your credits!
                </h3>
                <img
                  className="py-3"
                  src="https://scrollx-gif-uploads.s3.amazonaws.com/Fonts/Webp/Fonts-Font-Color-Changing_240305.webp"
                  alt=""
                />
              </div>
            </div>
          )}
          {/* Font Size */}
          <div
            className={
              fontSizeopt === true ? "InfoOverlay " : "InfoOverlayNone"
            }
          ></div>
          {fontSizeopt && (
            <div className="w-[90%] pr-[10%] h-[90%] overflow-y-auto scroll_bar">
              <div>
                <h1 className="py-3 text-black FontFamily-Avenir text-4xl FontFamily-Avenir">
                  Font Feature: Font Size
                </h1>
              </div>
              <div className="w-full">
                <h3 className="py-2 text-black FontFamily-Avenir text-3xl">
                  How to Change Font Size
                </h3>
                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  1. Select the Style to Edit
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Go to the Fonts section of your project and select the style
                  you wish to modify.
                </li>

                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  2. Adjust the Font Size
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Use the ▲/▼ stepper buttons to change the size.
                </li>
                <li className="py-1 FontFamily-Avenir-reg text-[17px]">
                  Alternatively, click on the font size and type a number
                  directly using your keyboard.
                </li>

                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  Design Recommendation
                </h3>

                <h3 className="py-2 text-black FontFamily-Avenir-reg text-[20px]">
                  To create typographic contrast between Roles and Names,
                  consider making the Names larger, changing their color, or
                  using a heavier weight. This enhances distinction and improves
                  the readability and visual appeal of your credits.
                </h3>
                <img
                  className="py-3"
                  src="https://scrollx-gif-uploads.s3.amazonaws.com/Fonts/Webp/Fonts-Font-Size-Options_240305.webp"
                  alt=""
                />
              </div>
            </div>
          )}
          {/* Line height */}
          <div
            className={
              fontlineheightopt === true ? "InfoOverlay " : "InfoOverlayNone"
            }
          ></div>
          {fontlineheightopt && (
            <div className="w-[90%] pr-[10%] h-[90%] overflow-y-auto scroll_bar">
              <div>
                <h1 className="py-3 text-black FontFamily-Avenir text-4xl FontFamily-Avenir">
                  Font Feature: Line Height
                </h1>
                <h2 className="py-2 text-black FontFamily-Avenir-reg text-[20px]">
                  Line height in credits sheets refers to the vertical spacing
                  between each line of text, which is crucial for maintaining
                  readability, aesthetic balance, and a professional appearance.
                  Here’s how line height plays an essential role and how to
                  adjust it effectively:
                </h2>
              </div>
              <div className="w-full">
                <h3 className="py-2 text-black FontFamily-Avenir text-3xl">
                  Importance of Line Height in Credits Sheets:
                </h3>
                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  1. Readability
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Proper line height ensures that each line of text is easily
                  distinguishable from the next. This is especially important in
                  credits, where information needs to be clear and legible even
                  when scrolling quickly.
                </li>

                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  2. Aesthetic Balance
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Adequate line height contributes to a clean and organized
                  look. Too little spacing can make the text appear cluttered,
                  while too much can make it look disjointed.
                </li>

                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  3. Professional Appearance
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Consistent line height across different sections of the
                  credits sheet enhances the overall professionalism of the
                  presentation. It ensures that the text flows smoothly without
                  abrupt changes in spacing.
                </li>

                <img
                  className="py-3"
                  src="https://scrollx-gif-uploads.s3.amazonaws.com/Fonts/Webp/Fonts-Line-height-Options-Gif-Co.webp"
                  alt=""
                />
                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  Conclusion
                </h3>

                <h3 className="py-2 text-black FontFamily-Avenir-reg text-[20px]">
                  Adjusting the line height in credits sheets is essential for
                  creating a readable, organized, and professional appearance.
                  By selecting the appropriate line height, you can ensure that
                  your credits are easy to read and aesthetically pleasing,
                  whether they are presented in a static format or scrolling on
                  screen.
                </h3>
              </div>
            </div>
          )}
          {/* text tranform */}
          <div
            className={
              fonttextTranformopt === true ? "InfoOverlay " : "InfoOverlayNone"
            }
          ></div>
          {fonttextTranformopt && (
            <div className="w-[90%] pr-[10%] h-[90%] overflow-y-auto scroll_bar">
              <div>
                <h1 className="py-3 text-black FontFamily-Avenir text-4xl FontFamily-Avenir">
                  Font Feature: Text Tranform
                </h1>
                <h2 className="py-2 text-black FontFamily-Avenir-reg text-[20px]">
                  Text transform is a CSS property that can be highly effective
                  when styling credits sheets. This property controls the
                  capitalization of text, allowing for consistent and
                  professional presentation without altering the underlying
                  content. Here’s how you can apply text transform to enhance
                  credits sheets:
                </h2>
              </div>
              <div className="w-full">
                <h3 className="py-2 text-black FontFamily-Avenir text-3xl">
                  Key Text Transform Values:
                </h3>
                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  1.None
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  No transformation is applied; text appears as it is originally
                  typed.
                </li>

                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  2. Capitalize
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Capitalizes the first letter of each word.
                </li>

                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  3. Uppercase
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Converts all characters to uppercase.
                </li>
                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  4. Lowercase
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Converts all characters to lowercase.
                </li>
                <img
                  className="py-3"
                  src="https://scrollx-gif-uploads.s3.amazonaws.com/Fonts/Webp/Fonts-Font-Transform-Options_240305.webp"
                  alt=""
                />
                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  Conclusion
                </h3>

                <h3 className="py-2 text-black FontFamily-Avenir-reg text-[20px]">
                  Using the text-transform property in CSS is a simple yet
                  powerful way to control the presentation of text in credits
                  sheets. By applying transformations such as uppercase,
                  capitalize, or lowercase, you can ensure a consistent and
                  professional appearance, making the credits easy to read and
                  aesthetically pleasing. This approach saves time and effort,
                  especially when dealing with extensive credits lists.
                </h3>
              </div>
            </div>
          )}
          {/* Letter Spacing*/}
          <div
            className={
              fontletterSpacingopt === true ? "InfoOverlay " : "InfoOverlayNone"
            }
          ></div>
          {fontletterSpacingopt && (
            <div className="w-[90%] pr-[10%] h-[90%] overflow-y-auto scroll_bar">
              <div>
                <h1 className="py-3 text-black FontFamily-Avenir text-4xl FontFamily-Avenir">
                  Font Feature: Letter Spacing
                </h1>
                <h2 className="py-2 text-black FontFamily-Avenir-reg text-[20px]">
                  Letter spacing, also known as tracking, refers to the
                  adjustment of space between characters in a piece of text. It
                  is an important aspect of typography that can significantly
                  affect the readability, appearance, and overall aesthetics of
                  the text. Proper letter spacing ensures that text is neither
                  too cramped nor too spread out, providing a balanced and
                  visually appealing presentation.
                </h2>
              </div>
              <div className="w-full">
                <h3 className="py-2 text-black FontFamily-Avenir text-3xl">
                  Key Aspects of Letter Spacing:
                </h3>
                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  1. Definition
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Letter spacing is the space between each character in a text.
                  It is different from kerning, which adjusts the space between
                  specific pairs of characters for optimal appearance.
                </li>

                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  2. Measurement
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Letter spacing is usually measured in em units, which are
                  relative to the current font size. For example, 0.1em adds a
                  space equal to 10% of the current font size between each
                  character.
                </li>
                <li className="py-1 FontFamily-Avenir-reg text-[17px]">
                  It can also be specified in pixels (px) or percentage (%).
                </li>

                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  3. Impact on Readability
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Increased letter spacing can enhance readability, especially
                  for headings or larger text.
                </li>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Decreased letter spacing can create a more compact and dense
                  look, which might be used for stylistic effects but can reduce
                  readability if overdone.
                </li>
                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  4. Aesthetic and Design Considerations
                </h3>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Proper letter spacing can give text a polished and
                  professional look. It can help differentiate headings from
                  body text and improve the overall visual hierarchy.
                </li>
                <li className="FontFamily-Avenir-reg text-[17px]">
                  Designers often adjust letter spacing to achieve a specific
                  aesthetic or to fit text within a given space without altering
                  the font size.
                </li>
                <img
                  className="py-3"
                  src="https://scrollx-gif-uploads.s3.amazonaws.com/Fonts/Webp/Fonts-Letter-spacing-Options_240305.webp"
                  alt=""
                />
                <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                  Conclusion
                </h3>

                <h3 className="py-2 text-black FontFamily-Avenir-reg text-[20px]">
                  Letter spacing is a crucial typographic tool that influences
                  the readability, aesthetics, and overall presentation of text.
                  By adjusting the space between characters, designers can
                  create visually appealing text that enhances user experience.
                  Proper use of letter spacing ensures that text is clear,
                  balanced, and aligned with the intended design goals, making
                  it an essential consideration in both print and digital
                  typography.
                </h3>
              </div>
            </div>
          )}
        </div>
        <div className="w-2/5 py-5 ">
          <h1 className="py-2 text-4xl FontFamily-Avenir">
            Font Customization Options
          </h1>
          <h2 className="text-[20px] FontFamily-Avenir-reg py-2 ">
            With ScrollX, you have the ability to modify the following font
            settings. Click for further information:
          </h2>
          <div className=" py-[4%] normal-case w-full text-[18px] place-items-start place-content-center grid gap-3 grid-cols-1 overflow-y-auto">
            <div
              key={1}
              className={`w-[90%] py-3 pl-2 flex items-center  justify-between cursor-pointer rounded border-[1px]  border-white-700 ${
                activeFont === "FontFamilytype" ? "active123" : "InfoLayoutOption"
              }`}
              id={"FontFamilytype"}
              onClick={() => nextToContinue("FontFamilytype")}
            >
              <div>Font Family</div>
            </div>
            <div
              key={2}
              className={`w-[90%] py-3 pl-2 flex items-center justify-between cursor-pointer rounded border-[1px]  border-white-700 ${
                activeFont === "FontWeighttype"
                  ? "active123"
                  : "InfoLayoutOption"
              }`}
              id={"FontWeighttype"}
              onClick={() => nextToContinue("FontWeighttype")}
            >
              <div className="w-full">Font Weight</div>
            </div>
            <div
              key={3}
              className={`w-[90%] py-3 pl-2 flex items-center justify-between cursor-pointer rounded border-[1px]  border-white-700 ${
                activeFont === "FontColortype"
                  ? "active123"
                  : "InfoLayoutOption"
              }`}
              id={"FontColortype"}
              onClick={() => nextToContinue("FontColortype")}
            >
              <div className="w-full">Font Color</div>
            </div>
            <div
              key={4}
              className={`w-[90%] py-3 pl-2 flex items-center justify-between cursor-pointer rounded border-[1px]  border-white-700 ${
                activeFont === "FontSizetype" ? "active123" : "InfoLayoutOption"
              }`}
              id={"FontSizetype"}
              onClick={() => nextToContinue("FontSizetype")}
            >
              <div className="w-full">Font Size</div>
            </div>
            <div
              key={5}
              className={`w-[90%] py-3 pl-2 flex items-center justify-between cursor-pointer rounded border-[1px]  border-white-700 ${
                activeFont === "Lineheighttype"
                  ? "active123"
                  : "InfoLayoutOption"
              }`}
              id={"Lineheighttype"}
              onClick={() => nextToContinue("Lineheighttype")}
            >
              <div className="w-full">Line Height</div>
            </div>
            <div
              key={6}
              className={`w-[90%] py-3 pl-2 flex items-center justify-between cursor-pointer rounded border-[1px]  border-white-700 ${
                activeFont === "textTranformtype"
                  ? "active123"
                  : "InfoLayoutOption"
              }`}
              id={"textTranformtype"}
              onClick={() => nextToContinue("textTranformtype")}
            >
              <div className="w-full">Text Tranform</div>
            </div>
            <div
              key={7}
              className={`w-[90%] py-3 pl-2 flex items-center justify-between cursor-pointer rounded border-[1px]  border-white-700 ${
                activeFont === "letterSpacingtype"
                  ? "active123"
                  : "InfoLayoutOption"
              }`}
              id={"letterSpacingtype"}
              onClick={() => nextToContinue("letterSpacingtype")}
            >
              <div className="w-full">Letter Spacing</div>
            </div>
            {/* Add more options */}
          </div>
        </div>
      </div>
    </div>
  );
}
